import { AirQualityClassificationType, AirQualityMarkerDto, AqiStandardV2Dto, PollutantConfigDto } from '../types';
import { calcDatasourcePollutantInfo, findAqiLevel, UNKNOWN_AQI_LEVEL } from './aqi';

export class MapData {
  constructor(
    public index: number,
    public marker: AirQualityMarkerDto
  ) {
    this.index = index;
    this.marker = marker;
  }

  get position() {
    return this.marker.location.coordinates;
  }

  get datasourceName() {
    return this.marker.datasourceName;
  }

  get datasourceId() {
    return this.marker.datasourceId;
  }

  get sourceType() {
    return this.marker.sourceType;
  }

  getMainPollutantAqiValue(pollutantConfigs: PollutantConfigDto[], aqiStandard: AqiStandardV2Dto): number | undefined {
    return calcDatasourcePollutantInfo(this.marker.metrics, pollutantConfigs, aqiStandard)[0].aqi;
  }

  getMainPollutantAqiDisplayValue(pollutantConfigs: PollutantConfigDto[], aqiStandard: AqiStandardV2Dto): string {
    const aqiVal = this.marker.isStale ? undefined : this.getMainPollutantAqiValue(pollutantConfigs, aqiStandard);
    if (aqiStandard.aqiClassType === AirQualityClassificationType.AQC) {
      const level = findAqiLevel(aqiStandard, aqiVal);
      if (level.aqiLevelId === UNKNOWN_AQI_LEVEL.aqiLevelId) {
        return '?';
      }

      return level.description[0]; // first letter of the description
    }
    return aqiVal?.toFixed(0).toString() ?? '';
  }

  getColor(aqiStandard: AqiStandardV2Dto, pollutantConfigs: PollutantConfigDto[]) {
    const aqi = this.marker.isStale ? undefined : this.getMainPollutantAqiValue(pollutantConfigs, aqiStandard);
    const aqiLevel = findAqiLevel(aqiStandard, aqi);
    return aqiLevel.color;
  }
}
